import { useDispatch, useSelector } from 'react-redux';
import { FlexContainer } from '@taxdown/piccolo-web';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { showModalAction } from 'Store/modules/app/actions';
import OneColLayout from 'Components/Layouts/OneColLayout';
import {
  TYPEFORM_ESTIMATED_RESULT_PREVIOUS_YEARS_URL,
  TYPEFORM_ESTIMATED_RESULT_URL,
} from 'Config';
import { plansNameMapping, PLAN_SHORT_NAME_DICTIONARY } from 'Constants/plans';
import { ENTERTAIMENT_MODAL } from 'Constants/modals';
import { setBodyOverflow } from 'Styles/utils/utils';
import { useGetUserCustomerData } from './hooks';
import * as Styled from './styles';

const DgTypeForm = (): JSX.Element => {
  const dispatch = useDispatch();
  const isPreviousYears = useSelector(routeStateSelector);
  const customer = useGetUserCustomerData();
  const URL = isPreviousYears?.products?.isPreviousYear
    ? TYPEFORM_ESTIMATED_RESULT_PREVIOUS_YEARS_URL
    : TYPEFORM_ESTIMATED_RESULT_URL;

  const openModal = (): void => {
    setBodyOverflow();
    dispatch(showModalAction({ options: { type: ENTERTAIMENT_MODAL } }));
  };

  return (
    <OneColLayout>
      <FlexContainer>
        <Styled.Iframe
          id={`${URL}id_usuario=${customer && customer?.userId}&plan=${
            plansNameMapping(customer?.activePlan?.name) || PLAN_SHORT_NAME_DICTIONARY.BASIC
          }`}
          onSubmit={openModal}
        />
      </FlexContainer>
    </OneColLayout>
  );
};

export default DgTypeForm;
